var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import ElementController from "../base-controllers/ElementController.js";
import { node } from "../base-controllers/element_controller/node_decorator.js";
const THRESHOLD = 80; // pixels to pull before triggering refresh
/**
 * Native pull-to-refresh for mobile.
 *
 * Detects a downward touch gesture
 * when the scroll container is at the top, shows a visual indicator,
 * and triggers a page reload when released past the threshold.
 *
 * Only attach on mobile (use {% if platform.is_mobile %} in the template).
 *
 * HTML contract:
 *
 *   <div data-slot="app-content"
 *        data-controller="PullToRefresh">
 *     <div data-slot="pull-indicator">
 *       {% icon "arrow-path" %}
 *     </div>
 *     <main>...</main>
 *   </div>
 */
class PullToRefresh extends ElementController {
    constructor() {
        super(...arguments);
        this.startY = 0;
        this.currentY = 0;
        this.pulling = false;
        this.handleTouchStart = (event) => {
            const e = event;
            // Only activate when scrolled to top.
            if (this.root.scrollTop <= 0) {
                this.startY = e.touches[0].clientY;
                this.pulling = true;
            }
        };
        this.handleTouchMove = (event) => {
            if (!this.pulling)
                return;
            const e = event;
            this.currentY = e.touches[0].clientY;
            const dy = this.currentY - this.startY;
            if (dy > 0 && this.root.scrollTop <= 0) {
                // Pulling down from top — prevent native scroll and show indicator.
                e.preventDefault();
                const progress = Math.min(dy / THRESHOLD, 1);
                const translateY = Math.min(dy * 0.5, THRESHOLD); // dampened
                if (this.indicator) {
                    this.indicator.style.transform = `translate(-50%, calc(-100% + ${translateY}px))`;
                    this.indicator.style.opacity = String(progress);
                }
            }
            else {
                // Scrolled away from top or swiping up — cancel.
                this.resetPull();
            }
        };
        this.handleTouchEnd = () => {
            if (!this.pulling)
                return;
            const dy = this.currentY - this.startY;
            if (dy >= THRESHOLD) {
                // Past threshold — trigger refresh.
                if (this.indicator) {
                    this.indicator.setAttribute("data-refreshing", "");
                }
                window.location.reload();
            }
            else {
                this.resetPull();
            }
        };
    }
    resetPull() {
        this.pulling = false;
        this.startY = 0;
        this.currentY = 0;
        if (this.indicator) {
            this.indicator.style.transform = "";
            this.indicator.style.opacity = "";
            this.indicator.removeAttribute("data-refreshing");
        }
    }
}
PullToRefresh.id = "PullToRefresh";
PullToRefresh.binds = {
    root: [
        ["touchstart", "handleTouchStart", { passive: true }],
        ["touchmove", "handleTouchMove", { passive: false }],
        ["touchend", "handleTouchEnd"],
    ],
};
export default PullToRefresh;
__decorate([
    node('[data-slot~="pull-indicator"]')
], PullToRefresh.prototype, "indicator", void 0);
//# sourceMappingURL=PullToRefresh.js.map